module.exports = __webpack_public_path__ + "img/brand1.45492f9e.png";